import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import "./index.scss";
import { VectorIcon } from "../../../assets/icons/VectorIcon";
import { useNavigate } from "react-router-dom";

const services = [
  {
    title: "Consulting Stratégique",
    description:
      "Notre cabinet de conseil vous accompagne : de l’analyse de marché à l’optimisation opérationnelle, nous transformons vos ambitions en résultats concrets.",
    link: "/consulting",
  },
  {
    title: "Développement Web",
    description:
      "Nous créons des solutions web performantes et scalables pour vos besoins (Sites vitrine, applications métier, e-commerce).",
    link: "/developpement",
  },
  {
    title: "Marketing Digital",
    description:
      "Maximisez votre visibilité et vos conversions grâce à une stratégie marketing digital personnalisée, SEO, publicité en ligne, réseaux sociaux.",
    link: "/marketing",
  },
  {
    title: "Design Graphique",
    description:
      "Notre équipe de design conçoit des identités visuelles qui augmentent les impacts : logo, charte graphique, supports de communication.",
    link: "/design",
    highlighted: true,
  },
];

const ServicesSection = () => {
  const navigate = useNavigate();
  return (
    <section className="services-apropos-section py-5">
      <div className="services-section-container">
        <Row className="g-5">
          <Col md={5} className="mb-4 text-white">
            <h2 className=" mt-5">
              Des services sur <br /> mesure
            </h2>
            <p className="mt-3">
              Notre approche à 360° couvre le conseil stratégique, le
              développement web, le marketing digital et le design graphique.
            </p>
            <Button
              variant="outline-light"
              className="rounded-pill mt-3"
              onClick={() => {
                navigate("/demandez-devis");
                window.scrollTo(0, 0);
              }}
            >
              Demandez un devis
            </Button>
          </Col>

          <Col md={7}>
            <Row className="gy-4">
              {services.map((service, index) => (
                <Col md={6} key={index}>
                  <Card
                    className={`service-card ${
                      service.highlighted ? "highlighted" : ""
                    } pt-5 pb-5`}
                    onClick={() => {
                      navigate(`${service?.link}`);
                      window.scrollTo(0, 0);
                    }}
                  >
                    <Card.Body>
                      <VectorIcon />
                      <h5 className=" mt-4">{service.title}</h5>
                      <p>{service.description}</p>
                      <span className="voir-plus">Voir Plus</span>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ServicesSection;
